import { registerEnumSet } from '@if/mui'
import { ECreditApplicationStatus } from '@if/core/types'

// Registers the credit-application statuses as enum chips (color + label per status)
// in the shared @if/mui registry, so any surface — the Manage Users stat chips + the
// Applications-cell pills, and anywhere else — reads one canonical color/label per
// status. Load-once side-effect, imported at app bootstrap (main.tsx).
// `secondary` (neutral slate) for expired, since the status palette has no plain grey.
registerEnumSet(ECreditApplicationStatus, {
  [ECreditApplicationStatus.Active]: { color: 'info', labelKey: 'UserStatsHeaders.active' },
  [ECreditApplicationStatus.Completed]: { color: 'success', labelKey: 'UserStatsHeaders.completed' },
  [ECreditApplicationStatus.Draft]: { color: 'warning', labelKey: 'UserStatsHeaders.draft' },
  [ECreditApplicationStatus.Expired]: { color: 'secondary', labelKey: 'UserStatsHeaders.expired' },
  [ECreditApplicationStatus.Cancelled]: { color: 'error', labelKey: 'UserStatsHeaders.cancelled' },
})
